import { apiRequest } from "./apiService";

/**
 * Backend:
 *  - GET   /notifications
 *  - PATCH /notifications/:id/read
 */

export const fetchNotifications = () => {
  return apiRequest("/notifications", "GET");
};

export const markNotificationAsRead = (notificationId) => {
  if (!notificationId) throw new Error("notificationId is required");
  return apiRequest(
    `/notifications/${encodeURIComponent(notificationId)}/read`,
    "PATCH"
  );
};
